import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  SupplierProfile,
  ListSuppliersRequest,
  ListSuppliersResponse,
  AdminUpdateSupplierRequest,
  SupplierActivityReportRequest,
  SupplierActivityReportResponse,
} from './supplier.type';
import { environment } from '../../environments/environment';

interface Envelope<T> { result: T; }

@Injectable({ providedIn: 'root' })
export class SupplierService {
  private apiUrl = environment.apiBaseURL + '/suppliers';

  constructor(private http: HttpClient) { }

  listSuppliers(request: ListSuppliersRequest = {}): Observable<ListSuppliersResponse> {
    let params = new HttpParams();
    if (request.pageIndex !== undefined) params = params.set('pageIndex', request.pageIndex);
    if (request.pageSize !== undefined) params = params.set('pageSize', request.pageSize);
    if (request.search) params = params.set('search', request.search);
    if (request.enabled !== undefined) params = params.set('enabled', request.enabled);
    return this.http
      .get<Envelope<ListSuppliersResponse>>(this.apiUrl, { params })
      .pipe(map(r => r.result));
  }

  /** Admin-only: a supplier's contact and payment details by user ID. */
  getSupplier(userId: string): Observable<SupplierProfile> {
    return this.http
      .get<Envelope<SupplierProfile>>(`${this.apiUrl}/${userId}`)
      .pipe(map(r => r.result));
  }

  /** The only path to priority, the contract allowance and the enabled flag. */
  updateSupplier(userId: string, request: AdminUpdateSupplierRequest): Observable<SupplierProfile> {
    return this.http
      .put<Envelope<SupplierProfile>>(`${this.apiUrl}/${userId}`, request)
      .pipe(map(r => r.result));
  }

  /** Registrations, activity and the signup funnel per day; see Reports → Suppliers. */
  getActivityReport(request: SupplierActivityReportRequest = {}): Observable<SupplierActivityReportResponse> {
    let params = new HttpParams();
    for (const [k, v] of Object.entries(request)) {
      if (v !== undefined && v !== null && v !== '') params = params.set(k, String(v));
    }
    return this.http
      .get<Envelope<SupplierActivityReportResponse>>(`${this.apiUrl}/reports/activity`, { params })
      .pipe(map(r => r.result));
  }
}
